<style lang="scss" src="./style.scss" scoped></style>
<script src="./script"></script>
<template>
  <article>
    <overlay :loading="isLoading">
      <div class="detail">
        <div class="row gx-2">
          <div class="col col-12">
            <div class="total-cpd mb-2">
              <h5>Bạn đang quản lí {{ $filters.comma(result.total.total) }} CPDs</h5>
              <div>
                <span>Cost: <span class="text-success">{{ $filters.short(result.total.cost) }}</span> </span> | <span>Discount: <span class="text-success">{{ $filters.short(result.total.discount) }}</span></span>
              </div>
            </div>
          </div>

          <div class="col col-12">
            <div class="pb-2 mb-2">
              <span v-if="result.today.total > 0">Có {{ $filters.comma(result.today.total) }} CPD được thêm vào hôm nay.</span>
              <span v-else>Hôm nay không có CPD được thêm mới</span>
            </div>
          </div>

          <div class="col col-12 col-md-6">
            <div class="card text-bg-primary mb-2">
              <div class="card-header">Đang chạy</div>
              <div class="card-body">
                <h5 class="card-title">{{ $filters.comma(result.normal.total) }}</h5>
                <div class="card-text">
                  <div>Cost: {{ $filters.short(result.normal.cost) }} </div>
                  <div>Discount: {{ $filters.short(result.normal.discount) }}</div>  
                </div>
              </div>
            </div>
          </div>

          <div class="col col-12 col-md-6">
            <div class="card text-bg-danger mb-2">
              <div class="card-header">Không hoạt động</div>
              <div class="card-body">
                <h5 class="card-title">{{ $filters.comma(result.inactive.total) }}</h5>
                <div class="card-text">
                  <div>Cost: {{ $filters.short(result.inactive.cost) }} </div>
                  <div>Discount: {{ $filters.short(result.inactive.discount) }}</div>
                </div>
              </div>
            </div>
          </div>

          <div class="col col-12 col-md-6">
            <div class="card text-bg-warning mb-2">
              <div class="card-header">Không hiển thị</div>
              <div class="card-body">
                <h5 class="card-title">{{ $filters.comma(result.hidden.total) }}</h5>
                <div class="card-text">
                  <div>Cost: {{ $filters.short(result.hidden.cost) }}</div>
                  <div>Discount: {{ $filters.short(result.hidden.discount) }}</div>
                </div>
              </div>
            </div>
          </div>

          <div class="col col-12 col-md-6">
            <div class="card text-bg-secondary mb-2">
              <div class="card-header">Đã hết hạn</div>
              <div class="card-body">
                <h5 class="card-title">{{ $filters.comma(result.expired.total) }}</h5>
                <div class="card-text">
                  <div>Cost: {{ $filters.short(result.expired.cost) }}</div>
                  <div>Discount: {{ $filters.short(result.expired.discount) }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </overlay>
  </article>
</template>